/**
 * Canonical profile image field is User.avatar.
 * Call sites may still carry aliases (avatarUrl, Google picture, etc.).
 */
export function resolveUserAvatar(user) {
  if (!user || typeof user !== "object") return null;
  return (
    user.avatar ||
    user.avatarUrl ||
    user.profileImage ||
    user.photo ||
    user.image ||
    user.profilePic ||
    user.picture ||
    null
  );
}

export function resolveUserDisplayName(user) {
  if (!user || typeof user !== "object") return "";
  const fromParts = [user.firstName, user.lastName].filter(Boolean).join(" ").trim();
  return fromParts || user.name || user.fullName || user.email || "";
}
